/**
 * Shared between the web app (web_myplann) and the React Native host (app_myplann).
 * The ramps both design systems build on — the page background the WebView
 * and its host have to agree on is grey[50], the brand blue is blue[600].
 */

export type ColorScale = {
	50: string;
	100: string;
	200: string;
	300: string;
	400: string;
	500: string;
	600: string;
	700: string;
	800: string;
	900: string;
};

export const greyScale: ColorScale = {
	50: "#FAFAFA",
	100: "#F5F5F5",
	200: "#E5E5E5",
	300: "#D4D4D4",
	400: "#A3A3A3",
	500: "#737373",
	600: "#525252",
	700: "#404040",
	800: "#262626",
	900: "#171717",
};

export const darkGreyScale: ColorScale = {
	50: "#1B1B1E",
	100: "#242427",
	200: "#303034",
	300: "#3D3D42",
	400: "#8C8C93",
	500: "#95959B",
	600: "#AFAFB5",
	700: "#C7C7CC",
	800: "#E1E1E4",
	900: "#F4F4F6",
};

export const blueScale: ColorScale = {
	50: "#E3F2FD",
	100: "#BBDEFB",
	200: "#90CAF9",
	300: "#64B5F6",
	400: "#42A5F5",
	500: "#2196F3",
	600: "#1E88E5",
	700: "#1976D2",
	800: "#1565C0",
	900: "#0D47A1",
};

export const darkBlueScale: ColorScale = {
	50: "#15324A",
	100: "#1B3E59",
	200: "#265575",
	300: "#7AB3E1",
	400: "#5EA3DC",
	500: "#4090D2",
	600: "#3480C6",
	700: "#2D70B3",
	800: "#26609E",
	900: "#1D4882",
};
